import React from 'react';
import clsx from 'clsx';
import { Typography } from '@/components/common';

interface Props {
	title: string;
	documentName: string;
	current: number;
	total: number;
}

export const ModalTitle: React.FC<Props> = ({
	title,
	documentName,
	current,
	total,
}) => {
	return (
		<div
			className={clsx(
				'flex flex-col lg:flex-row justify-between w-full items-center'
			)}
		>
			<div className={clsx('flex flex-col justify-start')}>
				<Typography
					type="semibold-20"
					className="text-left !text-base lg:!text-xl"
				>
					{title}
				</Typography>
				<Typography
					type="regular-14"
					className={clsx('text-gray-35 text-left hidden lg:block')}
				>
					{`${current} of ${total} • ${documentName}`}
				</Typography>
			</div>
		</div>
	);
};
